/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-impact micro-sequences`)
};

const es_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsecuencias posteriores al impacto`)
};

const de_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosequenzen nach dem Treffmoment`)
};

const zh_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球瞬间后的微动作顺序`)
};

const ar_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسلسلات دقيقة بعد لحظة الضرب`)
};

const fr_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro-séquences post-impact`)
};

const vi_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi chuỗi sau impact`)
};

const sw_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifuatano midogo baada ya kugonga mpira`)
};

const th_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลำดับการเคลื่อนไหวย่อยหลังจังหวะอิมแพ็ค`)
};

const bs_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekvence poslije impacta`)
};

const ja_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インパクト後の微細な連続動作`)
};

const ko_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임팩트 후의 미세 연속 동작`)
};

const pt_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microssequências após o impacto`)
};

const it_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro-sequenze dopo l'impatto`)
};

const sv_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekvenser efter träffen`)
};

const nl_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsequenties na het trefmoment`)
};

const da_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekvenser efter træfmomentet`)
};

const nb_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekvenser etter treffet`)
};

const fi_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osuman jälkeiset mikrosarjat`)
};

const pl_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekwencje po uderzeniu`)
};

const ru_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Микропоследовательности после удара`)
};

const tr_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuruş sonrası mikro diziler`)
};

const hi_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इम्पैक्ट के बाद के सूक्ष्म क्रम`)
};

const id_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan mikro setelah impact`)
};

const ms_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan mikro selepas hentaman`)
};

const cs_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrosekvence po úderu`)
};

const el_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μικροακολουθίες μετά την επαφή`)
};

const he_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רצפי מיקרו שאחרי הפגיעה`)
};

const af_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikro-effekte ná impak`)
};

const hu_method_content_step_04_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találat utáni mikroszekvenciák`)
};

/**
* | output |
* | --- |
* | "Post-impact micro-sequences" |
*
* @param {Method_Content_Step_04_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_tournament_0_heading(inputs)
	return en_method_content_step_04_detail_tournament_0_heading(inputs)
});